import { TPriorityQueueTypeId as TPriorityQueueTypeId$1, empty as empty$1, fromIterable as fromIterable$1, isEmpty as isEmpty$1, isNonEmpty as isNonEmpty$1, make as make$1, offer as offer$1, offerAll as offerAll$1, peek as peek$1, peekOption as peekOption$1, removeIf as removeIf$1, retainIf as retainIf$1, size as size$1, take as take$1, takeAll as takeAll$1, takeOption as takeOption$1, takeUpTo as takeUpTo$1, toChunk, toReadonlyArray as toReadonlyArray$1 } from '../../internal/stm/tPriorityQueue.esm.js';

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
const TPriorityQueueTypeId = TPriorityQueueTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * A `TPriorityQueue` contains values of type `A` that an `Order` is defined
 * on. Unlike a `TQueue`, `take` returns the highest priority value (the value
 * that is first in the specified ordering) as opposed to the first value
 * offered to the queue. The ordering that elements with the same priority will
 * be taken from the queue is not guaranteed.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @internal
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 */

/**
 * Constructs a new empty `TPriorityQueue` with the specified `Order`.
 *
 * @since 2.0.0
 * @category constructors
 */
const empty = empty$1;

/**
 * Makes a new `TPriorityQueue` initialized with provided iterable.
 *
 * @since 2.0.0
 * @category constructors
 */
const fromIterable = fromIterable$1;

/**
 * Checks whether the queue is empty.
 *
 * @since 2.0.0
 * @category getters
 */
const isEmpty = isEmpty$1;

/**
 * Checks whether the queue is not empty.
 *
 * @since 2.0.0
 * @category getters
 */
const isNonEmpty = isNonEmpty$1;

/**
 * Makes a new `TPriorityQueue` that is initialized with specified values.
 *
 * @since 2.0.0
 * @category constructors
 */
const make = make$1;

/**
 * Offers the specified value to the queue.
 *
 * @since 2.0.0
 * @category mutations
 */
const offer = offer$1;

/**
 * Offers all of the elements in the specified collection to the queue.
 *
 * @since 2.0.0
 * @category mutations
 */
const offerAll = offerAll$1;

/**
 * Peeks at the first value in the queue without removing it, retrying until a
 * value is in the queue.
 *
 * @since 2.0.0
 * @category getters
 */
const peek = peek$1;

/**
 * Peeks at the first value in the queue without removing it, returning `None`
 * if there is not a value in the queue.
 *
 * @since 2.0.0
 * @category getters
 */
const peekOption = peekOption$1;

/**
 * Removes all elements from the queue matching the specified predicate.
 *
 * @since 2.0.0
 * @category getters
 */
const removeIf = removeIf$1;

/**
 * Retains only elements from the queue matching the specified predicate.
 *
 * @since 2.0.0
 * @category getters
 */
const retainIf = retainIf$1;

/**
 * Returns the size of the queue.
 *
 * @since 2.0.0
 * @category getters
 */
const size = size$1;

/**
 * Takes a value from the queue, retrying until a value is in the queue.
 *
 * @since 2.0.0
 * @category mutations
 */
const take = take$1;

/**
 * Takes all values from the queue.
 *
 * @since 2.0.0
 * @category mutations
 */
const takeAll = takeAll$1;

/**
 * Takes a value from the queue, returning `None` if there is not a value in
 * the queue.
 *
 * @since 2.0.0
 * @category mutations
 */
const takeOption = takeOption$1;

/**
 * Takes up to the specified maximum number of elements from the queue.
 *
 * @since 2.0.0
 * @category mutations
 */
const takeUpTo = takeUpTo$1;

/**
 * Collects all values into a chunk.
 *
 * @since 2.0.0
 * @category destructors
 */
const toArray = toChunk;

/**
 * Collects all values into an array.
 *
 * @since 2.0.0
 * @category destructors
 */
const toReadonlyArray = toReadonlyArray$1;

export { TPriorityQueueTypeId, empty, fromIterable, isEmpty, isNonEmpty, make, offer, offerAll, peek, peekOption, removeIf, retainIf, size, take, takeAll, takeOption, takeUpTo, toArray, toReadonlyArray };
